// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const pl: KnowledgePagesCopy = {
  knowledgePage: 'Strona wiedzy',
  knowledgePages: 'Strony wiedzy',
  featureOffTitle: 'Strony wiedzy nie są włączone w tym obszarze roboczym.',
  featureOffBody: 'Kontekst firmy i źródła nadal znajdziesz w sekcji Wiedza.',
  loadingPage: 'Wczytywanie strony…',
  loadingSuggestion: 'Wczytywanie propozycji…',
  cancel: 'Anuluj',
  tryAgain: 'Spróbuj ponownie',
  everyoneIn: 'Wszyscy w {company}',
  yourCompany: 'twojej firmie',
  revision: 'Wersja {n}',
  openRevision: 'Otwórz wersję {n}',
  pageCount: 'one:strona|few:strony|many:stron|other:strony',
  topicCount: 'one:temat|few:tematy|many:tematów|other:tematu',
  sectionCount: 'one:sekcja|few:sekcje|many:sekcji|other:sekcji',
  lineCount: 'one:wiersz|few:wiersze|many:wierszy|other:wiersza',
  documentCount: 'one:dokument|few:dokumenty|many:dokumentów|other:dokumentu',
  changeCount: 'one:zmiana|few:zmiany|many:zmian|other:zmiany',
  newPageCount: 'one:nowa strona|few:nowe strony|many:nowych stron|other:nowej strony',
  changedPageCount:
    'one:zmieniona strona|few:zmienione strony|many:zmienionych stron|other:zmienionej strony',
  otherSectionCount: 'one:inna sekcja|few:inne sekcje|many:innych sekcji|other:innej sekcji',
  characterCount: 'one:znak|few:znaki|many:znaków|other:znaku',
  diffStats: 'Zmieniono: {sections} · dodano: {added} · usunięto: {removed}',
  diffMatchesBase: 'Proponowany tekst jest zgodny z wersją bazową.',
  diffIntroduction: 'Wprowadzenie',
  diffOtherUnchanged: '{sections} bez zmian.',
  timeJustNow: 'przed chwilą',
  originImportedFrom: 'Zaimportowano z {path}',
  originImportedFromCommit: 'Zaimportowano z {path} @ {commit}',
  authorityApprovedInPoneva: 'Zatwierdzono w Poneva',
  authorityImported: 'Zaimportowano',
  authorityInRepository: '{canonicality} w repozytorium',
  authorityVerified: 'zweryfikowano {date}',
  authorRepositoryImport: 'Import z repozytorium',
  authorSuggestedInChat: 'Zaproponowane na czacie',
  authorSuggestedInChatWith: 'Zaproponowane na czacie z {name}',
  authorSuggestedBy: 'Zaproponowane przez {name}',
  authorSuggestedByApp: 'Zaproponowane przez połączoną aplikację',
  authorSuggestedByColleague: 'Zaproponowane przez współpracownika',
  authorSuggestedByYou: 'Zaproponowane przez ciebie',
  authorSuggestedOnBehalf: 'Zaproponowane przez {app} w imieniu {name}',
  authorSuggestedByAppOnBehalf: 'Zaproponowane przez połączoną aplikację w imieniu {name}',
  authorSuggestedAndApproved: 'Zaproponowane i zatwierdzone przez {name}',
  approverApprovedBy: 'zatwierdzone przez {name}',
  approverAppliedBy: 'zastosowane przez {name}',
  kindCreatePage: 'Nowa strona',
  kindUpdatePage: 'Proponowana aktualizacja',
  kindArchivePage: 'Archiwizacja',
  statusConflict: 'Konflikt · strona się zmieniła',
  statusPending: 'Czeka na sprawdzenie',
  statusApproved: 'Zatwierdzono',
  statusRejected: 'Odrzucono',
  statusWithdrawn: 'Wycofano',
  statusSuperseded: 'Nieaktualna',
  errRevisionConflict: 'Ta strona zmieniła się, gdy ją sprawdzałeś.',
  errProposalChanged:
    'Ta propozycja zmieniła się, gdy ją sprawdzałeś. Zanim zdecydujesz, sprawdź najnowszą wersję.',
  errPublishRequired:
    'Tylko osoby publikujące w firmie mogą zatwierdzać zmiany wiedzy lub importować strony.',
  errProposalLimit:
    'Twoja firma ma już 200 propozycji czekających na sprawdzenie. Sprawdź część z nich, zanim zaproponujesz kolejne.',
  errAuthorLimit:
    'Masz już 50 propozycji czekających na sprawdzenie. Zaczekaj na decyzję w sprawie części z nich albo wycofaj niektóre, zanim zaproponujesz kolejne.',
  errImportProposalLimit:
    'Ten import dodałby więcej zmienionych stron do sprawdzenia, niż mieści kolejka twojej firmy (maksymalnie 200). Rozstrzygnij część propozycji w zakładce Do sprawdzenia, a potem zastosuj import ponownie.',
  errImportChanged:
    'To nie jest import, który sprawdzałeś. Otwórz go ponownie i sprawdź przed zastosowaniem.',
  errImportItemNotFound: 'Ten dokument nie jest już częścią importu.',
  errIdempotencyConflict:
    'Ta propozycja została już wysłana z inną treścią. Odśwież i spróbuj ponownie.',
  errImportHashMismatch:
    'Plik w tej migawce nie zgadza się z zapisaną sumą kontrolną. Utwórz migawkę ponownie i spróbuj jeszcze raz.',
  errImportAlreadyApplied: 'Ten import został już zastosowany.',
  errImportDiscarded: 'Ten import został odrzucony. Wybierz plik migawki ponownie.',
  errImportDuplicateItem: 'Ta migawka zawiera ten sam dokument dwa razy. Utwórz migawkę ponownie.',
  errInvalidImport:
    'Poneva nie może przyjąć tej migawki. Utwórz ją ponownie skryptem migawki i spróbuj jeszcze raz.',
  errInvalidInput: 'Poneva nie może przyjąć tych danych. Sprawdź pola i spróbuj ponownie.',
  errImportLimit:
    'Zbyt wiele importów jest przygotowanych, ale niezastosowanych. Zastosuj lub odrzuć część z nich, zanim przygotujesz kolejny.',
  errPageTooLarge: 'Strona jest większa niż 256 KB. Podziel ją na mniejsze strony.',
  errTooManySections: 'Strona ma więcej niż 2000 nagłówków. Podziel ją na mniejsze strony.',
  errPageLimit: 'Twoja firma osiągnęła limit 2000 stron wiedzy.',
  errCollectionLimit: 'Twoja firma osiągnęła limit 100 tematów.',
  errProposalNotPending:
    'W sprawie tej propozycji już zdecydowano. Wyświetlany status jest aktualny.',
  errRequesterRemoved:
    'Osoba, która to zaproponowała, nie należy już do tej firmy, więc nie można tego zatwierdzić.',
  errRevisionAlreadyCurrent: 'Ta wersja jest już bieżąca.',
  errPageArchived:
    'Ta strona została zarchiwizowana, gdy ją sprawdzałeś. Zanim zdecydujesz, sprawdź propozycję ponownie.',
  errAlreadyArchived: 'Ta strona jest już zarchiwizowana.',
  errProposalForbidden: 'Tylko osoba, która to zaproponowała, może to wycofać.',
  errUnavailable: 'Strony wiedzy są teraz niedostępne.',
  errTimeout: 'Poneva zbyt długo nie odpowiada.',
  errItemTooLarge: '{path} jest większy niż 256 KB. Podziel go na mniejsze strony.',
  errItemTooManySections: '{path} ma więcej niż 2000 nagłówków. Podziel go na mniejsze strony.',
  errItemHashMismatch:
    '{path} nie zgadza się z zapisaną sumą kontrolną. Utwórz migawkę ponownie i spróbuj jeszcze raz.',
  errNoLongerAvailable: 'Ten element nie jest już dla ciebie dostępny.',
  errTooLargeToSend: 'Ten plik jest za duży, aby go wysłać.',
  cardChecking: 'Sprawdzanie statusu…',
  cardNotAvailable: 'Niedostępne',
  cardStatusUnavailable: 'Status niedostępny',
  cardUnshowable: 'Nie udało się wyświetlić tej proponowanej aktualizacji wiedzy.',
  cardEyebrow: 'Proponowana aktualizacja wiedzy',
  cardLabel: 'Proponowana aktualizacja wiedzy · {title}',
  cardMissing: 'Ta propozycja nie jest już dla ciebie dostępna.',
  cardUnknown:
    'Nie udało się sprawdzić, na jakim etapie jest ta propozycja. Otwórz ją, aby zobaczyć jej status.',
  cardCheckAgain: 'Sprawdź ponownie',
  cardReview: 'Sprawdź aktualizację',
  statusLineApproved: 'Zatwierdzona wiedza',
  readyCount:
    'one:gotowy do wyszukiwania|few:gotowe do wyszukiwania|many:gotowych do wyszukiwania|other:gotowego do wyszukiwania',
  preparingCount:
    'one:w przygotowaniu|few:w przygotowaniu|many:w przygotowaniu|other:w przygotowaniu',
  attentionCount: 'one:wymaga uwagi|few:wymagają uwagi|many:wymaga uwagi|other:wymaga uwagi',
  topicsExplore: 'Przeglądaj temat',
  topicsAllPages: 'Wszystkie strony',
  topicsOpenPages: 'Otwórz Strony',
  topicsEmpty:
    'Nie ma jeszcze zatwierdzonych stron. Strony zawierają obszerną wiedzę o firmie wraz z pełną historią wersji.',
  reviewsTitle: 'Proponowane aktualizacje stron',
  reviewsTitleMine: 'Twoje proponowane aktualizacje stron',
  reviewsIntro:
    'Każda propozycja to kompletna wersja kandydująca wraz z uzasadnieniem i dowodami. Nic się nie zmieni, dopóki nie zatwierdzisz dokładnie tej wersji.',
  reviewsIntroMine:
    'Twoje propozycje czekają tutaj, aż sprawdzi je osoba publikująca w firmie. Do tego czasu strony pozostają bez zmian.',
  loadPagesFailed: 'Nie udało się wczytać stron wiedzy.',
  loadProposalsFailed: 'Nie udało się wczytać proponowanych aktualizacji stron.',
  loadMoreFailed: 'Nie udało się wczytać kolejnych stron.',
  otherPages: 'Inne strony',
  loadTopicFailed: 'Nie udało się wczytać tego tematu.',
  revisionShort: 'w{n}',
  updatedOn: 'Zaktualizowano {date}',
  emptyTitle: 'Nie ma jeszcze stron wiedzy.',
  emptyBody:
    'Strony zawierają zatwierdzoną, obszerną wiedzę twojej firmy — kierunek, decyzje i sposób pracy — z zachowaniem każdej wersji. Zaimportuj je z migawki repozytorium albo utwórz stronę na czacie; każdą stronę zatwierdza osoba publikująca w firmie, zanim stanie się ona wiedzą firmy.',
  importFromSnapshot: 'Importuj z migawki repozytorium',
  startInChat: 'Utwórz stronę na czacie',
  startInChatPrompt:
    'Pomóż mi utworzyć stronę wiedzy dla naszej firmy. Zapytaj, co ma obejmować, i nie wymyślaj treści. Pozostanie propozycją, dopóki nie zatwierdzi jej osoba publikująca w firmie.',
  loadingPages: 'Wczytywanie stron wiedzy…',
  filterLabel: 'Filtruj strony według tytułu',
  filterPlaceholder: 'Filtruj strony',
  importButton: 'Importuj',
  showingTopic: 'Wyświetlany temat: {topic}',
  showAllTopics: 'Pokaż wszystkie tematy',
  loadingTopic: 'Wczytywanie tematu…',
  noMatch: 'Żadna strona nie pasuje do „{filter}”.',
  topicNoPages: 'W tym temacie nie ma jeszcze zatwierdzonych stron.',
  loading: 'Wczytywanie…',
  loadMore: 'Wczytaj więcej stron',
  metaApproved: 'zatwierdzono {date}',
  metaRepositoryAuthoritative: 'źródłem prawdy pozostaje repozytorium',
  loadPageFailed: 'Nie udało się wczytać tej strony.',
  loadHistoryFailed: 'Nie udało się wczytać historii wersji.',
  outlineLabel: 'Sekcje strony',
  outlineToggle: 'Na tej stronie',
  loadingHistory: 'Wczytywanie historii wersji…',
  historyLabel: 'Historia wersji',
  historyIntro:
    'Każda zatwierdzona wersja jest zachowywana. Przywrócenie wcześniejszej tworzy propozycję do sprawdzenia; nigdy nie usuwa późniejszych wersji.',
  historyCurrent: 'Bieżąca',
  historyViewing: 'Wyświetlana',
  historyView: 'Wyświetl',
  historyViewAria: 'Wyświetl wersję {n}',
  restoreAria: 'Przywróć jako propozycję: wersja {n}',
  restoreCreating: 'Tworzenie propozycji…',
  restore: 'Przywróć jako propozycję',
  restoreUnconfirmed:
    'Nie udało się potwierdzić, że propozycja została utworzona. Zanim spróbujesz ponownie, zajrzyj do zakładki Do sprawdzenia.',
  editTooLarge:
    'Ta strona jest większa niż 256 KB. Zanim ją zaproponujesz, podziel ją na mniejsze strony.',
  editConflict:
    'Ta strona zmieniła się podczas edycji. Skopiuj swój tekst, otwórz najnowszą wersję i zaproponuj zmianę ponownie.',
  editUnconfirmed:
    'Nie udało się potwierdzić, że twoja propozycja została wysłana. Zanim wyślesz ją ponownie, zajrzyj do zakładki Do sprawdzenia.',
  editHeading: 'Zaproponuj zmianę',
  editIntro:
    'Edytujesz wersję {n}. Osoba publikująca w firmie sprawdza dokładnie tę zmianę, zanim stanie się ona wersją {next}; do tego czasu strona pozostaje bez zmian.',
  editOutdated:
    'Podczas edycji zatwierdzono nowszą wersję. Skopiuj swój tekst, a potem zacznij od najnowszej wersji, aby nie utracić wprowadzonych w niej zmian.',
  editContentLabel: 'Treść strony (Markdown)',
  editReasonLabel: 'Dlaczego ta zmiana?',
  editReasonPlaceholder: 'Co się zmieniło i skąd to wiadomo.',
  editSending: 'Wysyłanie…',
  editSend: 'Wyślij do sprawdzenia',
  editDiscardConfirm: 'Odrzucić tę zmianę? Nic z tego, co zmieniłeś, nie zostało wysłane.',
  editNoChanges: 'Nie ma jeszcze zmian.',
  editNeedsContent: 'Strona musi mieć jakąś treść.',
  exportFailed: 'Nie udało się wyeksportować tej strony. Spróbuj ponownie.',
  askPagePrompt: 'Pytanie o stronę wiedzy „{title}” (wersja {n}, {link}):',
  askPageSectionPrompt: 'Pytanie o stronę wiedzy „{title}” § {section} (wersja {n}, {link}):',
  pageMissingTitle: 'Ta strona jest niedostępna.',
  pageMissingBody: 'Mogła zostać zarchiwizowana albo nie masz już dostępu do wiedzy tej firmy.',
  pageArchived: 'Zarchiwizowana',
  viewingRevisionCurrent: 'Wyświetlasz wersję {n}; bieżąca wersja to {current}.',
  viewingRevisionOld: 'Wyświetlasz wersję {n}. To nie jest bieżąca wersja.',
  openCurrent: 'Otwórz bieżącą',
  archivedBanner:
    'Ta strona jest zarchiwizowana. Nie jest już uwzględniana w odpowiedziach; jej historia jest zachowana.',
  pageViewsLabel: 'Widoki strony',
  tabRead: 'Czytaj',
  tabHistory: 'Historia',
  unknownSection: 'Wskazana sekcja nie należy do tej wersji. Wyświetlana jest cała strona.',
  askAboutPage: 'Zapytaj o tę stronę',
  exporting: 'Eksportowanie…',
  exportMarkdown: 'Eksportuj do Markdown',
  loadSuggestionFailed: 'Nie udało się wczytać tej propozycji.',
  evidenceSource: 'Źródło',
  evidenceFact: 'Kontekst firmy',
  evidenceResult: 'Zapisana praca',
  evidenceUrl: 'Strona internetowa',
  evidenceDecision: 'Decyzja',
  evidenceReference: 'Odniesienie',
  evidenceOpenPage: 'Otwórz stronę wiedzy',
  evidenceOpenSource: 'Otwórz źródło',
  evidenceOpenFact: 'Otwórz kontekst firmy',
  evidenceOpenResult: 'Otwórz zapisaną pracę',
  evidenceOpenUrl: 'Otwórz stronę internetową',
  evidenceOpenDecision: 'Otwórz decyzję',
  evidenceOpenReference: 'Otwórz odniesienie',
  evidenceDecisionNote: 'Zarejestrowana decyzja. W Poneva nie ma czego otworzyć.',
  evidenceFactGone: 'Ten kontekst firmy nie jest już zapisany.',
  evidencePageNoRevision: 'Ta strona nie ma zatwierdzonej wersji do otwarcia.',
  evidencePrivateExcerpt: 'Prywatny dowód — udostępniono tylko powyższy fragment.',
  evidencePrivate: 'Prywatny dowód — jego treść nie została ci udostępniona.',
  evidenceHeading: 'Dowody',
  evidenceNone: 'Nie dołączono żadnych dowodów. Oceń samo powyższe uzasadnienie.',
  changeAdded: 'Dodano',
  changeRemoved: 'Usunięto',
  changeChanged: 'Zmieniono',
  changeUnchanged: 'Bez zmian',
  moreLineCount:
    'one:kolejny wiersz|few:kolejne wiersze|many:kolejnych wierszy|other:kolejnego wiersza',
  moreUnchangedLineCount:
    'one:kolejny niezmieniony wiersz|few:kolejne niezmienione wiersze|many:kolejnych niezmienionych wierszy|other:kolejnego niezmienionego wiersza',
  unchangedLineCount:
    'one:niezmieniony wiersz|few:niezmienione wiersze|many:niezmienionych wierszy|other:niezmienionego wiersza',
  skipAdded: '{lines} — widoczne w pełnej wersji',
  skipRemoved: 'Usunięto {lines}',
  cutUnchanged: 'Pominięto {lines}',
  cutChanged: 'Pominięto {lines}, {changes}. Sprawdź je w pełnej wersji.',
  cutAddedRemoved: 'dodano: {added}, usunięto: {removed}',
  cutAdded: 'dodano: {added}',
  cutRemoved: 'usunięto: {removed}',
  lineAddedSr: 'Dodano:',
  lineRemovedSr: 'Usunięto:',
  noLinesAdded: 'Nowa sekcja. Jej tekst znajdziesz w pełnej wersji poniżej.',
  noLinesRemoved: 'Ta sekcja zostałaby usunięta ze strony.',
  noLinesChanged: 'Ta sekcja się zmienia. Jej tekst znajdziesz w pełnej wersji poniżej.',
  diffHeading: 'Zmiany',
  outcomeArchived: 'Zarchiwizowano.',
  outcomeArchivedBody:
    'Strona {title} nie jest już uwzględniana w odpowiedziach i zniknęła z listy stron. Jej wersje, ta propozycja i decyzja pozostają w historii strony.',
  openArchivedPage: 'Otwórz zarchiwizowaną stronę',
  outcomeApproved: 'Zatwierdzono.',
  outcomeApprovedRevision: 'Wersja {n} jest teraz zatwierdzoną wersją strony {title}.',
  outcomeApprovedPlain: 'Ta propozycja została zatwierdzona.',
  outcomeRestored: 'Strona wróciła na listę stron i znów jest uwzględniana w odpowiedziach.',
  outcomeKept: 'Propozycja, decyzja i wszystkie wcześniejsze wersje pozostają w historii strony.',
  openPage: 'Otwórz stronę',
  outcomeDismissed: 'Odrzucono.',
  outcomeWithdrawn: 'Wycofano.',
  outcomeSuperseded: 'Nieaktualna.',
  outcomeSupersededBody:
    'Nowsza wersja, propozycja lub import z repozytorium sprawiły, że ta propozycja stała się nieaktualna. Sama niczego nie zmieniła.',
  outcomeUnchanged: 'Strona pozostaje bez zmian.',
  approveNewPage: 'Zatwierdź nową stronę',
  approveArchive: 'Zatwierdź archiwizację',
  approveRestoreRevision: 'Przywróć i zatwierdź wersję {n}',
  approveRevision: 'Zatwierdź wersję {n}',
  approveArchiveNote: 'Zatwierdzenie archiwizuje tę stronę dla wszystkich w {company}.',
  approvePublishNote: 'Zatwierdzenie publikuje tę wersję dla wszystkich w {company}.',
  approvePublishEvidenceNote:
    'Zatwierdzenie publikuje tę wersję oraz pokazane powyżej fragmenty dowodów dla wszystkich w {company}.',
  archivedTitle: 'Ta strona jest zarchiwizowana.',
  alreadyArchivedBody:
    'Zatwierdzenie niczego by nie zmieniło, więc tę propozycję można tylko odrzucić.',
  archivedRestoreBody:
    'Zatwierdzenie ją przywróci: strona wróci na listę stron, do wyszukiwania i odpowiedzi z tą wersją.',
  staleRevisionAction: 'Porównaj z najnowszą wersją',
  staleProposalTitle: 'Ta propozycja zmieniła się, gdy ją sprawdzałeś.',
  staleProposalAction: 'Sprawdź najnowszą wersję',
  staleArchivedTitle:
    'Ta strona została zarchiwizowana, gdy ją sprawdzałeś. Zatwierdzenie tej propozycji ją przywróci.',
  staleArchivedAction: 'Sprawdź ponownie',
  suggestionMissingTitle: 'Ta propozycja jest niedostępna.',
  suggestionMissingBody:
    'Mogła zostać wycofana albo należy do innej osoby i nie została wysłana do sprawdzenia w firmie.',
  decideUnconfirmed:
    'Nie udało się potwierdzić twojej decyzji. Wyświetlany status jest najnowszym statusem z Poneva; sprawdź go, zanim spróbujesz ponownie.',
  decideFailed: 'Nie udało się zapisać twojej decyzji.',
  discussPrompt:
    'Pomóż mi dopracować proponowaną aktualizację wiedzy dla strony „{title}” ({link}).',
  conflictBody:
    'Ta propozycja została przygotowana na podstawie wersji {base}; bieżąca wersja to {current}. Zatwierdzenie nadpisałoby tę zmianę, więc w obecnej postaci nie można jej zatwierdzić.',
  conflictBodyPlain:
    'Ta propozycja została przygotowana na podstawie wcześniejszej wersji, więc w obecnej postaci nie można jej zatwierdzić.',
  openLatest: 'Otwórz najnowszą wersję',
  reworkInChat: 'Popraw na czacie',
  factReason: 'Uzasadnienie',
  factNoReason: 'Nie podano uzasadnienia.',
  factAudience: 'Odbiorcy',
  factRevision: 'Wersja',
  revisionNew: 'Nowa strona, wersja 1',
  revisionArchiveAfter: 'Archiwizacja po wersji {n}',
  revisionWrittenAgainst: 'Przygotowana na podstawie wersji {base}; bieżąca wersja to {current}',
  revisionCurrentToProposed: 'Bieżąca wersja {base} → proponowana wersja {next}',
  revisionProposed: 'Proponowana wersja {next}',
  proposedPage: 'Proponowana strona',
  archivingHeading: 'Co daje archiwizacja',
  archivingBody:
    'Strona przestaje być uwzględniana w odpowiedziach i znika z listy stron. Jej wersje i ta decyzja są zachowywane.',
  noComparison: 'Porównanie sekcji nie jest dostępne dla tej propozycji.',
  showComplete: 'Pokaż pełną wersję',
  approving: 'Zatwierdzanie…',
  dismissing: 'Odrzucanie…',
  dismiss: 'Odrzuć',
  withdrawing: 'Wycofywanie…',
  withdraw: 'Wycofaj',
  editInChat: 'Edytuj na czacie',
  waitingForPublisher: 'Czeka, aż sprawdzi to osoba publikująca w firmie.',
  snapshotTooLarge: 'Ta migawka jest większa niż 8 MB. Utwórz ją z mniejszą liczbą dokumentów.',
  snapshotNotSnapshot:
    'Ten plik nie jest migawką wiedzy. Wybierz plik JSON zapisany przez skrypt migawki.',
  snapshotEmpty: 'Ta migawka nie zawiera dokumentów.',
  readDocumentFailed: 'Nie udało się odczytać tego dokumentu. Spróbuj ponownie.',
  readingDocument: 'Odczytywanie dokumentu…',
  hideText: 'Ukryj tekst',
  readText: 'Czytaj tekst',
  textOf: 'Tekst: {title}',
  gitSnapshot: 'Migawka Git {commit}',
  repositorySnapshot: 'Migawka repozytorium',
  importNewHeading: '{pages} · zatwierdzane po zastosowaniu',
  importNewNote:
    'Każda zostanie opublikowana jako zatwierdzona strona dla wszystkich w {company}, bez dalszego sprawdzania. Przeczytaj każdą z nich, zanim zastosujesz import.',
  importChangedHeading: '{pages} · wysyłane do sprawdzenia',
  importChangedNote:
    'Każda staje się proponowaną aktualizacją. Jej strona zmieni się dopiero wtedy, gdy osoba publikująca w firmie zatwierdzi ją w zakładce Do sprawdzenia, która pokazuje, co się zmieniło.',
  unchangedDocumentCount:
    'one:niezmieniony dokument|few:niezmienione dokumenty|many:niezmienionych dokumentów|other:niezmienionego dokumentu',
  unchangedNote:
    'Te dokumenty są już zgodne z zatwierdzonymi stronami. Nic nie zostanie dla nich zapisane.',
  stagedHeading: 'Przygotowane, ale niezastosowane',
  excludedSummary: 'Pominięte w tej migawce: {documents}',
  countsLine: '{newPages} · {changedPages} do sprawdzenia · bez zmian: {unchanged}',
  importAlreadyDiscarded: 'Ten import został już odrzucony.',
  confirmLabel: 'Potwierdź import',
  unchangedKeepCount:
    'one:niezmieniony dokument zachowuje swoją stronę|few:niezmienione dokumenty zachowują swoje strony|many:niezmienionych dokumentów zachowuje swoje strony|other:niezmienionego dokumentu zachowuje swoje strony',
  confirmBody:
    'Zastosować ten import dla wszystkich w {company}? Jako wersja 1 zostaną zatwierdzone: {newPages}; na sprawdzenie poczekają: {changedPages}; a {unchanged}. Wcześniejsze propozycje z importu dla tych stron zostaną wycofane.',
  applying: 'Stosowanie…',
  applyImport: 'Zastosuj import',
  chooseAnother: 'Wybierz inny plik',
  allCurrent: 'Wszystko w tej migawce jest już aktualne.',
  importApplied: 'Import zastosowany.',
  appliedSummary: 'Utworzono: {pages} · czeka na sprawdzenie: {changes} · bez zmian: {unchanged}.',
  appliedIndexing:
    'Nowe strony będzie można wyszukiwać na czacie po zakończeniu indeksowania. Postęp widać w przygotowaniu źródeł.',
  openPages: 'Otwórz strony',
  reviewChanges: 'Sprawdź zmiany ({changes})',
  checkIndexing: 'Sprawdź postęp indeksowania',
  sendSnapshotFailed: 'Nie udało się wysłać tej migawki. Spróbuj ponownie.',
  openStagedFailed: 'Nie udało się otworzyć tego przygotowanego importu.',
  applyUnconfirmed:
    'Nie udało się potwierdzić, czy import został zastosowany. Zanim spróbujesz ponownie, zajrzyj do zakładki Strony.',
  applyFailed: 'Nie udało się zastosować tego importu.',
  importHeading: 'Importuj strony z repozytorium',
  backToPages: 'Wróć do stron',
  importLead:
    'Utwórz migawkę poleceniem {command}, a potem wybierz plik. Zanim cokolwiek zostanie zapisane, zobaczysz każdy dokument i to, co by zmienił.',
  snapshotFileLabel: 'Plik migawki wiedzy',
  readingSnapshot: 'Odczytywanie migawki…',
  openingStaged: 'Otwieranie przygotowanego importu…',
  chooseSnapshot: 'Wybierz plik migawki',
  factOrigin: 'Pochodzenie',
  factContents: 'Zawartość',
  importOnlyListed: 'Importowane są tylko dokumenty wymienione tutaj.',
  importRepositoryAuthoritative:
    'Źródłem prawdy pozostaje repozytorium; zmienione dokumenty stają się propozycjami do sprawdzenia.',
  overviewReviewChanges: 'Sprawdź zmiany',
  overviewConnectAgents: 'Połącz zewnętrznych agentów',
  overviewEyebrow: 'Wspólne rozumienie',
  overviewTitle: '{company} w kontekście.',
  overviewLeadFallback:
    'Wiedza twojej firmy zaczyna się od kontekstu, którym się dzielisz. Budujcie wspólnie rozumienie swojej działalności.',
  overviewBody:
    'Kontekst firmy i materiały źródłowe dają Poneva punkt wyjścia — a nie wszystko, co można wiedzieć o {company}. Rozwijaj to rozumienie wraz z rozwojem firmy.',
  overviewAskPrompt: 'Co wiesz o naszej firmie i co warto byłoby dodać?',
  overviewAsk: 'Zapytaj o {company}',
  overviewAddSources: 'Dodaj źródła',
  contextEyebrow: 'Co nadaje odpowiedziom kontekst',
  contextTitle: 'Firma stojąca za pytaniem.',
  contextBody:
    'Źródła ze stron internetowych opisują publiczną stronę firmy. Notatki firmowe dodają waszą terminologię, priorytety i sposób pracy.',
  contextPrompt:
    'Pomóż mi doprecyzować priorytety firmy i preferencje dotyczące pracy, które powinniśmy zapamiętać.',
  contextAction: 'Zbuduj nasze rozumienie',
  learnEyebrow: 'Miejsce na naukę',
  learnTitle: 'Zacznij od tego, co ważne teraz.',
  learnBody:
    'Dodaj materiały źródłowe lub doprecyzuj, jak działa twoja firma. Poneva może proponować trwałe zmiany do twojego sprawdzenia.',
  learnPrompt:
    'Na podstawie obecnej wiedzy o naszej firmie: jakich ważnych informacji brakuje do pracy, którą chcemy wykonać?',
  learnAction: 'Omów, co byłoby przydatne',
  canvasEmptyTitle: 'Odrobina kontekstu bardzo pomaga.',
  canvasEmptyBody:
    'Profil firmy to punkt wyjścia. Dodaj materiały źródłowe i sprawdzone notatki, aby pomóc Poneva zrozumieć twoją pracę.',
  pageEyebrow: 'Obszar roboczy {company}',
  pageTitle: 'Wiedza firmy',
  pageDescription: 'Źródła i wiedza, na których opiera się praca Poneva.',
  tabOverview: 'Przegląd',
  tabPages: 'Strony',
  tabSources: 'Źródła',
  tabReview: 'Do sprawdzenia',
  proposalApproved: 'Zatwierdzony kontekst firmy',
  proposalDismissed: 'Odrzucona propozycja',
  proposalRemoval: 'Proponowane usunięcie',
  proposalCorrection: 'Proponowana poprawka',
  proposalContext: 'Proponowany kontekst firmy',
  proposalCurrent: 'Obecna wiedza',
  proposalFactGone:
    'Zapisany fakt nie jest już dostępny. Odśwież wiedzę firmy, zanim sprawdzisz to usunięcie.',
  proposalReviewFallback: 'Sprawdź proponowany kontekst firmy.',
  proposalNotSaved: 'Jeszcze niezapisane. Oryginalne źródła pozostają bez zmian.',
  proposalWaiting:
    'Czeka na sprawdzenie · decyzję podejmuje osoba publikująca w Skrzynce odbiorczej',
  proposalSaving: 'Zapisywanie…',
  proposalApproveRemoval: 'Zatwierdź usunięcie',
  proposalApproveClarification: 'Zatwierdź doprecyzowanie',
  factLabel: 'Fakt o firmie',
  factEyebrow: 'Fakt · Wszyscy w {company}',
  factSuggestCorrection: 'Zaproponuj poprawkę',
  factAskPrompt: 'Pomóż mi zrozumieć lub doprecyzować ten zapisany kontekst firmy: „{content}”',
  factAsk: 'Zapytaj o to',
  companyContextHeading: 'Kontekst firmy',
  companyContextPrompt:
    'Chcę doprecyzować wiedzę o naszej firmie. Pomóż mi przejrzeć, co wiemy, i zaproponować aktualizację.',
  companyContextEmpty:
    'Nie ma jeszcze zatwierdzonych notatek. Rozpocznij rozmowę o swojej firmie albo dodaj materiały źródłowe poniżej.',
  refineInChat: 'Dopracuj na czacie',
  reviewPanelLabel: 'Zmiany wiedzy do sprawdzenia',
  suggestedUpdatesHeading: 'Proponowane aktualizacje',
  suggestedUpdatesIntro:
    'Propozycje z twoich rozmów. To ty decydujesz, co stanie się trwałą częścią wiedzy twojej firmy.',
  reviewEmptyTitle: 'Nic nie czeka na twoje sprawdzenie.',
  reviewEmptyBody:
    'Gdy Poneva zaproponuje zmianę w wiedzy twojej firmy, znajdziesz ją tutaj. Trwałe zmiany zawsze wymagają twojego zatwierdzenia.',
  reviewEmptyPrompt:
    'Pomóż mi przejrzeć wiedzę o naszej firmie i zaproponuj, co warto doprecyzować w następnej kolejności.',
  inclusionPendingApproval: 'Zmianę uwzględnienia w wiedzy wysłano do zatwierdzenia.',
  sourcesFileIncluded: 'Plik uwzględniono w wyszukiwaniu wiedzy dla jego obecnych odbiorców.',
  sourcesAddFailed: 'Nie udało się dodać tego źródła.',
  sourcesHeading: 'Materiały, na których opierają się odpowiedzi.',
  sourcesIntro:
    'Poneva przeszukuje pełne materiały źródłowe, a nie tylko przegląd. Zachowuj oryginały, sprawdzaj, co jest gotowe, i wybieraj, na czym mają się opierać twoje odpowiedzi.',
  addSourceHeading: 'Dodaj materiały ze swojej firmy',
  addSourceIntro:
    'Przesłane źródła pozostają prywatne w twojej Bibliotece i są uwzględniane tylko w twoich odpowiedziach. Wybierz Udostępnij, gdy zechcesz udostępnić je współpracownikom.',
  uploadSource: 'Prześlij źródło',
  addSourcePrompt:
    'Pomóż mi dodać oświadczenie firmy jako wspólne źródło wewnętrzne. Zapytaj, co chcę zapisać; nie wymyślaj żadnej treści. Trwałe zmiany w wiedzy o firmie nadal wymagają mojego zatwierdzenia.',
  addThroughChat: 'Dodaj przez czat',
  addingSource: 'Dodawanie…',
  addToKnowledge: 'Dodaj do wiedzy',
  uploadFormats: 'TXT, Markdown, CSV i JSON · Do 5 MB na plik',
  sourceExcluded: 'Wykluczone z odpowiedzi',
  sourcePreparationFailed: 'Przygotowanie nie powiodło się',
  sourcePreparing: 'Przygotowywanie do wyszukiwania',
  sourceWaiting: 'Czeka na przygotowanie',
  sourceReadinessUnknown: 'Stan gotowości niedostępny',
  sourceRetryQueued:
    'Przygotowanie dodano do kolejki. Stan gotowości zaktualizuje się po jego zakończeniu.',
  sourceIncludedNotice: 'Źródło uwzględnione. Poneva przygotuje je do wyszukiwania.',
  sourceExcludedNotice: 'Wykluczono z odpowiedzi. Oryginalne źródło zostaje zachowane.',
  sourceUpdateFailed: 'Nie udało się zaktualizować tego źródła.',
  sourceOriginalMaterial: 'Oryginalny materiał źródłowy',
  sourceDiscuss: 'Omów na czacie',
  sourceDiscussPrompt: 'Pomóż mi zrozumieć lub doprecyzować „{title}”.',
  sourceExclude: 'Wyklucz z odpowiedzi',
  sourceInclude: 'Uwzględnij w odpowiedziach',
  sourcesLoadFailed: 'Nie udało się wczytać twoich źródeł.',
  sourceLibraryLabel: 'Biblioteka źródeł firmy',
  sourceListCaption: 'Oryginalne źródła · uwzględnione i wykluczone',
  sourceSearchLabel: 'Szukaj w źródłach firmy',
  sourceSearchPlaceholder: 'Szukaj w swoich źródłach…',
  sourcesFinding: 'Wyszukiwanie twoich źródeł…',
  sourcePagesLabel: 'Strony źródeł',
  sourceRange: '{from}–{to} z {count}',
  sourceCount: 'one:źródło|few:źródła|many:źródeł|other:źródła',
  sourcePrevious: 'Poprzednia',
  sourceNext: 'Następna',
  sourceNoMatchTitle: 'Brak pasujących źródeł.',
  sourceNoMatchBody: 'Spróbuj innej frazy lub nazwy źródła.',
  sourceEmptyTitle: 'Daj swoim pytaniom lepszy punkt wyjścia.',
  sourceEmptyBody:
    'Dodaj dokumenty firmowe, dane produktowe lub notatki robocze. Poneva może korzystać z pełnych materiałów źródłowych w rozmowach i Skills.',
  indexCheckFailed: 'Nie udało się sprawdzić przygotowania źródeł.',
  indexRetryQueued:
    'Nieudane wpisy wiedzy dodano do kolejki przygotowania. Twoje materiały źródłowe pozostają bez zmian.',
  indexQueueFailed: 'Nie udało się dodać przygotowania do kolejki. Spróbuj ponownie.',
  indexPreparing: 'Przygotowywanie nowej wiedzy do twoich rozmów…',
  indexAttention: 'Część wiedzy wymaga uwagi.',
  queuing: 'Dodawanie do kolejki…',
  retryPreparation: 'Ponów przygotowanie',
  sourceKindStatement: 'Oświadczenie firmy',
  sourceKindWebsite: 'Strona internetowa',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:odpowiedź|few:odpowiedzi|many:odpowiedzi|other:odpowiedzi',
  factUsedThisWeek: 'Użyto w tym tygodniu: {answers}',
  factLastUsed: 'ostatnio użyto: {when}',
  factToday: 'dzisiaj',
  factYesterday: 'wczoraj',
  factImpact: 'Ta zmiana dotyczy faktu użytego w tym tygodniu ({answers}).',
  factCorrectionAbout: 'W sprawie tego faktu o firmie: „{content}” ({link})',
  factCorrectionOutdated: 'To jest nieaktualne:',
  sourceCanvasRecorded: 'Zarejestrowany materiał źródłowy',
  sourceCanvasNotIncluded:
    'Nie wchodzi w skład wiedzy firmy. Oryginał jest przechowywany do wglądu i nadal można go użyć w konkretnej rozmowie.',
  sourceCanvasOpenOriginal: 'Otwórz oryginalne źródło',
  sourceCanvasUnavailable: 'Treść źródła jest niedostępna.',
  sourceCanvasDiscussPrompt: 'Pomóż mi zrozumieć lub doprecyzować „{title}”.',
  sourceCanvasDiscuss: 'Omów to źródło',
  sourceCanvasCorrectionNote:
    'Poprawka staje się proponowanym kontekstem firmy. Zarejestrowane źródło pozostaje bez zmian.',
  contextCanvasEyebrow: 'Dostępny kontekst firmy',
  contextCanvasTitle: 'Wiedza stojąca za tą rozmową.',
  contextCanvasBody:
    'Zatwierdzona wiedza i materiały źródłowe dodane przez twoją firmę. Dostępne na czacie i w Skills.',
  contextCanvasOpen: 'Otwórz sekcję Wiedza',
};

export default pl;
